document.addEventListener("DOMContentLoaded", () => {
  let loading = false;

  const grid = document.querySelector(".collection .product-grid");
  const pagination = document.querySelector(".pagination");

  if (!grid || !pagination) return;

  async function loadMoreProducts() {
    if (loading) return;
    loading = true;

    const nextUrl = pagination.querySelector("a[rel='next']");
    if (!nextUrl) return;

    const response = await fetch(nextUrl.href);
    const text = await response.text();
    const parser = new DOMParser();
    const doc = parser.parseFromString(text, "text/html");

    const newProducts = doc.querySelectorAll(
      ".collection .product-grid .grid__item"
    );
    const newPagination = doc.querySelector(".pagination");

    newProducts.forEach((p) => grid.appendChild(p));

    pagination.innerHTML = newPagination.innerHTML;

    loading = false;
  }

  window.addEventListener("scroll", () => {
    const bottom =
      window.innerHeight + window.scrollY >=
      document.body.offsetHeight - 500;

    if (bottom) {
      loadMoreProducts();
    }
  });
});
